import { createSlice } from '@reduxjs/toolkit';

import axios from 'utils/axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    company: null,
    firstName: null,
    lastName: null,
    phone: null,
    phoneCountryCode: null,
    profilePic: null,
    username: null,
    tokenCount: null
};

const slice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else {
                state.error = action.payload;
            }
        },
        setInfo(state, action) {
            state.company = action.payload.company;
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.phone = action.payload.phone;
            state.phoneCountryCode = action.payload.phoneCountryCode;
            state.profilePic = action.payload.profilePic;
            state.username = action.payload.username;
        },
        setTokenCount(state, action) {
            state.tokenCount = action.payload.count;
        }
    }
});

export default slice.reducer;

export function getProfileDetail(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/user/profile/detail', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setInfo(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updateProfile(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/user/profile/update', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setInfo(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function changePassword(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/user/profile/change-password', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function deleteAccount(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/user/delete', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback(response);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getScopes(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/user/scopes', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback(response.data.scopes);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}


export function getTokenCount(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/user/token', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setTokenCount(response.data));
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}
